export const RPC_URLS = {
  ETH_MAINNET: "https://mainnet.infura.io/v3/3e829f3608eb478797eee04aa2a7a5f8",
  BSC_MAINNET: "https://bsc-dataseed.binance.org",
};
